import {
  Avatar,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import { allDocentesAction } from '../DocentesAction';

const SelectFieldDocentesComponent = ({
  onChange,
  id = 'select-docentes',
  open = false,
  value,
  isEmpty = false,
  isAll = true,
  selects = [],
  label,
  required = false,
  error = false,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const [docentes, setDocentes] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (docentesStore.all && docentesStore.all.length === 0) {
        await allDocentesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setDocentes(docentesStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      docentesStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setDocentes(items);
    } else {
      setDocentes(docentesStore.all);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`${id}-select-label`}>
        {label ?? CONST.docente.label}
      </InputLabel>
      <Select
        labelId={`${id}-select-label`}
        id={`${id}-select`}
        value={value}
        label={label ?? CONST.docente.label}
        defaultValue={value}
        defaultOpen={open}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty ||
          (isAll && (
            <MenuItem key={`${id}-000-empty`} value={null}>
              {isAll ? 'TODOS' : 'NINGUNO'}
            </MenuItem>
          ))}
        {docentes.map((el, index) => {
          return (
            <MenuItem key={`${id}-${index}-item`} value={el.id}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Avatar
                  alt={el.usuario.perfil.avatar}
                  sx={{ width: 30, height: 30 }}
                  src={getFilesArchivos(el.usuario.perfil.avatar)}
                />
                <Typography
                  variant="body1"
                  color="initial"
                  sx={{ fontWeight: 'bold' }}
                >
                  {el.usuario.perfil.pnombre} {el.usuario.perfil.papellido}
                </Typography>
              </Stack>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectFieldDocentesComponent;
